<template>
  <div class="pb-16 pt-4 max-w-123 w-full container">
    <base-link class="mb-5 flex gap-1 items-center" :to="$router.options.history.state.back?.toString() || '/sign-in'">
      <vf-icon dir="left" name="chevron" size="md" />
      <span class="text-sm">{{ $t.backToSignIn }}</span>
    </base-link>
    <form-forgot-password />
  </div>
</template>

<script lang="ts" setup>
const { $t } = useNuxtApp()
useSeoMeta({ title: $t.forgotPasswordTitle })
</script>
